.list {
  background-color: var(--background-paper);
  width: 100%;
  min-width: 300px;
}
